import { create } from 'zustand';
import { VariationsFilter } from '../../ContentV3/helpers/contentVariationUtils';
import { VariationsMetricsByWeekRecord, VariationsMetricsByCategoryRequestType } from '../ContentServerProxy/types';

enum GroupByFieldType {
  Category = 'category',
  Subcategory = 'subcategory',
  Brand = 'brand'
}

interface VariationsAnalyticState {
  variationsFilter: VariationsFilter;
  variationsMetricsData: VariationsMetricsByWeekRecord[];
  setMainVariationsFilter: (filter: VariationsFilter) => void;
  setVariationsMetricsData: (data: VariationsMetricsByWeekRecord[]) => void;
}

export const mapVariationsFilterToRequestType = (filter: VariationsFilter): VariationsMetricsByCategoryRequestType => {
  const mapping: Record<VariationsFilter, VariationsMetricsByCategoryRequestType> = {
    [VariationsFilter.ChildVariationRate]: VariationsMetricsByCategoryRequestType.VariationAccuracyByCategory,
    [VariationsFilter.SingleSkuPages]: VariationsMetricsByCategoryRequestType.SingleSkuCountByCategory,
    [VariationsFilter.VariatedSkuPages]: VariationsMetricsByCategoryRequestType.VariatedSkuCountByCategory,
    [VariationsFilter.ChildAccuracy]: VariationsMetricsByCategoryRequestType.ChildAccuracyByCategory,
    [VariationsFilter.CorrectChildSkus]: VariationsMetricsByCategoryRequestType.CorrectChildCountByCategory,
    [VariationsFilter.IncorrectChildSkus]: VariationsMetricsByCategoryRequestType.IncorrectChildCountByCategory,
    [VariationsFilter.ParentPageAccuracy]: VariationsMetricsByCategoryRequestType.ParentPageAccuracyByCategory,
    [VariationsFilter.InaccurateParentPages]: VariationsMetricsByCategoryRequestType.InaccurateParentCountByCategory,
    [VariationsFilter.PageDensity]: VariationsMetricsByCategoryRequestType.PageDensityByCategory,
    [VariationsFilter.ParentPageCount]: VariationsMetricsByCategoryRequestType.ParentPageCountByCategory
  };

  return mapping[filter];
};

export const useVariationsAnalyticStore = create<VariationsAnalyticState>((set) => ({
  variationsFilter: VariationsFilter.ChildVariationRate,
  variationsMetricsData: [],
  setMainVariationsFilter: (filter: VariationsFilter) => {
    set({ variationsFilter: filter });
  },
  setVariationsMetricsData: (data: VariationsMetricsByWeekRecord[]) => {
    set({ variationsMetricsData: data });
  }
}));

export { GroupByFieldType };
